import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { map, path, pathOr } from 'ramda';
import { ContactSummary } from './ContactSummary';
import { CompanyDemographyInformations } from './CompanyDemographyInformations';
import { useContactRoleLabel } from './useContactRoleLabel';
import CompanyContacts from './CompanyContacts';

// Le bloc « Garanties » sera ajouté par MIDDLE-2577/2578
export const SummaryGroupProtection = ({
  getMiddleText, getMiddleBoolean, project, demography, regimeObligatoire, isProjectEditable
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const contacts = pathOr([], ['contacts'], project);
  const company = pathOr(null, ['company'], project);

  const getRoleLabel = useContactRoleLabel(getMiddleText);

  const contactTabs = map((contact) => {
    const role = path(['role'], contact);
    return {
      label: getRoleLabel(role),
      content: <ContactSummary contact={contact} getMiddleText={getMiddleText} />
    };
  }, contacts);

  const hasMultipleContacts = contacts.length > 1;
  const singleContact = contacts.length === 1 ? contacts[0] : null;

  return (
    <div className="flex flex-col items-center gap-4 w-full">
      {company && demography && (
        <CompanyDemographyInformations
          company={company}
          demography={demography}
          getMiddleBoolean={getMiddleBoolean}
          regimeObligatoire={regimeObligatoire}
          isProjectEditable={isProjectEditable}
        />
      )}

      <CompanyContacts
        hasMultipleContacts={hasMultipleContacts}
        contactTabs={contactTabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        contacts={contacts}
        singleContact={singleContact}
        getMiddleText={getMiddleText}
        isProjectEditable={isProjectEditable}
      />
    </div>
  );
};

SummaryGroupProtection.propTypes = {
  getMiddleText: PropTypes.func.isRequired,
  getMiddleBoolean: PropTypes.func,
  project: PropTypes.shape({
    contacts: PropTypes.array,
    company: PropTypes.object
  }).isRequired,
  demography: PropTypes.object,
  regimeObligatoire: PropTypes.object,
  isProjectEditable: PropTypes.bool
};
